import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth as useAuthHook, UseAuthOptions } from './useAuth';

interface AuthContextType {
  token: string | null;
  isAuthenticated: boolean;
  user: string | null;
  loading: boolean;
  error: any;
  login: (credentials: {
    username: string;
    password: string;
  }) => Promise<string>;
  logout: () => void;
  validateToken: (testToken?: string) => Promise<boolean>;
  refreshAuth: () => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps extends UseAuthOptions {
  children: ReactNode;
}

export function AuthProvider({ children, ...options }: AuthProviderProps) {
  const auth = useAuthHook(options);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuthContext(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}
